"use client";

import { Box, Container, List, ListItem, ListItemButton, ListItemText, Stack, Typography } from "@mui/material";
import { useContext } from "react";
import MenuContext from "@/context/MenuProvider";
import color from "@/style/theme/Color";
import { mainLayananNavMenus } from "@/layout/Navbar/Side/Sub/SubLayanan";

const SubLayanan = () => {
  const { stateAppBar, setStateAppBar } = useContext(MenuContext)!;

  const toggleSubAppBar = (anchor, open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setStateAppBar({ ...stateAppBar, [anchor]: open });
  };

  const closeSubAppBar = () => {
    setStateAppBar({
      subAppBarTentangKami: false,
      subAppBarKoleksi: false,
      subAppBarLayanan: false,
      subAppBarBantuan: false
    });
  };

  return <Box
    sx={{
      paddingTop: "1em",
      paddingBottom: "1em",
      width: "100%",
      backgroundColor: color.white_transparent,
      backdropFilter: "blur(10px)",
      position: "fixed",
      top: "64px",
      right: "0",
      left: "0",
      zIndex: "10"
    }}
    onMouseOver={toggleSubAppBar("subAppBarLayanan", true)}
    onMouseOut={closeSubAppBar}
  >
    <Container maxWidth="lg">
      <Stack direction="row" spacing={12}>
        <Typography sx={{ width: "300px", marginTop: "10px" }}>
          Berbagai layanan yang tersedia di Perpustakaan Politeknik Statistika STIS.
        </Typography>

        <List>
          {mainLayananNavMenus.map((menu, key) => (
            <ListItem key={key} disablePadding>
              <ListItemButton
                href={menu.path ?? '#'}
                sx={{
                  borderBottom: "1px solid rgb(230,230,230)",
                  borderLeft: "1px solid rgb(230,230,230)"
                }}
              >
                <ListItemText primary={menu.title}/>
              </ListItemButton>
            </ListItem>
          ))}
        </List>
      </Stack>
    </Container>
  </Box>;
};

export default SubLayanan;
